module.exports = __webpack_public_path__ + "img/解决方案_EMS_白.92cd98e2.svg";